import notepad from '../../assets/images/notepad.svg';

export const NotepadSrc = {
  src: notepad,
  alt: 'Notebook',
};
